

$('html').on('click', '.notification .action-buttons', function(e){
    e.preventDefault();
    e.stopPropagation();
    return false;
})